// extracted by mini-css-extract-plugin
module.exports = {"offeringItem":"FilterOfferingList_offeringItem__2mB49","padding":"FilterOfferingList_padding__2PdnF","smallDevicePadding":"FilterOfferingList_smallDevicePadding__3jbnY"};